import { CollectionAsset, CollectionFolder } from 'editor/src/store/collections/types';
import { SlotFileSetFolder } from 'editor/src/store/design/types';
import { CollectionDisplayOption, getElementCollectionAssets } from 'editor/src/store/plugins/utils/advPersoUtils';

/** The pictures a picture-set folder offers: its curated subset when one was picked, else all. */
function getSlotFolderAssets(folder: CollectionFolder | undefined, ref: SlotFileSetFolder): CollectionAsset[] {
  if (!folder) {
    return [];
  }
  return getElementCollectionAssets(folder, {
    folderId: ref.folderId,
    displayOption: CollectionDisplayOption.Dropdown,
    assetIds: ref.assetIds?.length ? ref.assetIds : undefined,
  });
}

export default getSlotFolderAssets;
